import _ from 'lodash';
import { applyPatches, createDraft, finishDraft, current, enablePatches } from 'immer';

import { enableInspector, actions } from '@/lib/redux/redux-inspector';
import { store } from './store';

enablePatches();
if (!window.__REDUX_DEVTOOLS_EXTENSION__) {
  enableInspector();
  Object.defineProperty(window, 'actions', {
    enumerable: false,
    value: actions,
  });
}

Object.defineProperty(window, '$state', {
  enumerable: false,
  get: () => {
    const state = store.getState();
    _.prototype.unwrap = function unwrap() {
      return current(this.value());
    };
    _.prototype.flush = function flush() {
      finishDraft(this.value(), (patches) => {
        store.dispatch({
          type: 'dev/FLUSH_STATE',
          payload: applyPatches(state, patches),
        });
      });
    };
    return _.chain(createDraft(state));
  },
});
